module.exports = __webpack_public_path__ + "static/media/mini_games_gif.5570fd8c.gif";